import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.templateList,"item-value":"id","item-text":"name","label":"Document Template","readonly":_vm.readonly,"rules":[_vm.requiredCheck()],"outlined":"","dense":""},model:{value:(_vm.idValue),callback:function ($$v) {_vm.idValue=$$v},expression:"idValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }